import React, { useState, useEffect } from 'react';
import style from "./css/Syndicate.module.css";
import { apiURL_BACKEND, UserDataInterface, useJustifyUserType, Transaction } from './Vars';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
interface SyndicateProps {

}


interface referrerUsers {
    name: string,
    referrer: string | null,
    dateJoined: string,
    balance: number,
}


const SyndicatePage: React.FC<SyndicateProps> = () => {
    const navigate = useNavigate();
    const userType = useJustifyUserType();
    const [downliners, setDownliner] = useState<Array<referrerUsers>>([]);
    const [userData, setUserData] = useState<UserDataInterface>();
    const [userDataDownline, setUserDataDownline] = useState<UserDataInterface>();
    useEffect(() => {


        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username: data.tme_username
            })
        });


        // setUserData({
        //     username:res.
        // })
    }, [])


    useEffect(() => {
        const res = axios.post(`${apiURL_BACKEND}/getDownline/`, {
            "username": userData?.referrer
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {

            setUserDataDownline(res.data.userData)
            console.log("er");
            setDownliner(res.data.referrers);
        }).catch((err) => {
            console.log(err);
        })
    }, [])

    useEffect(() => { console.log(" data downline ", userDataDownline) }, [userDataDownline])
    const udpateDownlineTree = (username: string) => {
        const res = axios.post(`${apiURL_BACKEND}/getDownline/`, {
            "username": username
        }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {

            setUserDataDownline(res.data.userData);
            setDownliner(res.data.referrers);
        }).catch((err) => {
            console.log(err);
        })
    }

    const buyPlan = () => {
        navigate('/Upgrade/');
    }


    const [transactions, setTransactions] = useState<Array<Transaction>>([])
    useEffect(() => {
        axios.get(`${apiURL_BACKEND}/getTransactionHistory/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            const data = res.data;
            setTransactions(data.transactions);
            console.log("transactions ",data.transactions)
        }).catch((err) => {
            console.log(err);
        })
    }, [])
    return (
        <>
            <div className={style.picksPalace}>
                <div className={style.pseudoSideNav}>

                </div>
                <div className={style.picksPalaceMain}>

                    <div className={style.section1}>
                        <div className={style.currentPlan}>
                            <p className={style.currentPlanTitle}>
                                Current Plan
                            </p>

                            <div className={style.currentPlanCard}>

                                <div className={style.packDetails}>
                                    <div>
                                        <p className={style.cardTitle} style={{ whiteSpace: "wrap", width: "100%" }}>
                                            {

                                                userData?.package ?
                                                    (<>Package</>) :
                                                    (<>No Package is Activated <br />
                                                        <span style={{ fontSize: "30px" }}>Buy Essential Pack</span>  </>)

                                            }
                                        </p>
                                    </div>


                                    <div className={style.amount}>
                                        <p>599 USD</p>
                                        <span>(-3%)</span>
                                    </div>
                                </div>


                                <ul className={style.ul1}>
                                    <li>1 month of free access to all picks.</li>
                                </ul>
                                <div className={style.card_1m}>
                                    <p className={style.t1}>
                                        After the 1st month
                                    </p>
                                    <ul className={style.ul2}>
                                        <li>5 picks per day.</li>
                                        <li>DayPass: 99 USD .</li>
                                        <li>WeekPass: 299 USD .</li>
                                        <li>MonthPass: 699 USD .</li>
                                    </ul>
                                </div>

                                <div className={style.upgradeButton} onClick={(e) => { e.preventDefault(); buyPlan(); }}>
                                    {
                                        userData?.package ?
                                            (<>Upgrade Plan</>) :
                                            (<>Buy a Package</>)
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={style.premiumPlan}>
                            <h2 className={style.prePlanHeader1}>
                                Upgrade to premium !
                            </h2>
                            <p className={style.prePlanT1}>
                                Premium Pack–$899(includes one month of free access to all picks)
                            </p>

                            <div className={style.prePlanAdvantages}>
                                <h2 className={style.prePlanAdvantagesHeader1}>
                                    After the first month (6 picks per day):
                                </h2>
                                <ul className={style.prePlanAdvantages_ul}>
                                    <li className={style.prePlanAdvatages_li}>DayPass:$79</li>
                                    <li className={style.prePlanAdvatages_li}>MonthPass:$549</li>
                                    <li className={style.prePlanAdvatages_li}>WeekPass:$249</li>
                                    <li className={style.prePlanAdvatages_li}>YearPass: $5,499</li>
                                </ul>

                            </div>

                            <button className={style.upgradePremiumPlanButton}>
                                Upgrade now
                            </button>
                        </div>
                    </div>

                    <div className={style.paymentHistory}>
                        <p>
                            Your Activites over the month
                        </p>

                        <table className={style.DepositsAndWithdrwals}>
                            {/* <tr><th colSpan={3}>
                                Deposits & Withdrawals
                            </th></tr> */}
                            <tr>
                                <td className={style.table_title}> Amount </td>
                                <td className={style.table_title}> Date </td>
                                <td className={style.table_title}> Action Type </td>
                            </tr>
                            {
                                transactions.map((t) => {
                                    return <>

                                        <tr>
                                            <td className={t.type=="withdrawal" || t.type=="buy" ? style.deposit : style.withdrawal}>
                                                {t.type=="withdrawal" ?'-':'+'}{t.amount}
                                                
                                                </td>
                                            <td className={style.table_date}>{t.date_created}</td>
                                            <td className={style.table_date}>{t.type}</td>
                                        </tr>

                                    </>
                                })
                            }


                        </table>
                    </div>

                    <h1 className={style.treeTitle}>
                        Unilayer Downline Tree
                    </h1>
                    <div className={style.downLineTreeContainer}>
                        <div className={style.tree}>
                            <div className={style.treeNode}>

                                <div className={style.treeNodeData} onClick={(e) => { e.preventDefault(); udpateDownlineTree(userDataDownline?.referrer ? userDataDownline?.referrer : ""); console.log(userDataDownline) }}>
                                    <div className={style.treeNodeProfileInfo}>
                                        <div className={style.treeNodeProfile}>
                                            <img src="" alt="" className={style.treeNodeProfile_img} />
                                            <div className={style.treeNodeProfile_username}>
                                                @{userDataDownline?.username}
                                            </div>
                                        </div>

                                        {/* <p className={style.treeNodeProfileInfoName}>Anwar jibewi</p> */}
                                    </div>


                                    <div className={style.treeNodeProfileData}>
                                        <div className={style.treeNodeData_key}>Plan Type</div>
                                        <div className={style.treeNodeData_value}></div>
                                    </div>

                                    <div className={style.treeNodeProfileData}>
                                        <div className={style.treeNodeData_key}>Balance</div>
                                        <div className={style.treeNodeData_value}>{userDataDownline?.balance} USD</div>
                                    </div>

                                    <div className={style.treeNodeProfileData}>
                                        <div className={style.treeNodeData_key}>Referrer</div>
                                        <div className={style.treeNodeData_value}>@{userDataDownline?.referrer}</div>
                                    </div>

                                    <div className={style.treeNodeProfileData}>
                                        <div className={style.treeNodeData_key}>Date Joined</div>
                                        <div className={style.treeNodeData_value}>{userDataDownline?.date_joined.substring(0, 10)}</div>
                                    </div>
                                </div>

                                {
                                    downliners.length > 0 ? (
                                        <>
                                            <div className={style.treeNodeClimber}></div>

                                        </>

                                    ) : (<></>)
                                }
                                <div className={style.treeNodeChildrens}>
                                    {
                                        downliners.length > 1 ? (
                                            <>
                                                <div className={style.treeNodeHorizontalLine}></div>
                                            </>

                                        ) : (<></>)
                                    }

                                    <div className={style.treeNodeChilds}>

                                        {
                                            downliners.map((downliner, index) => (
                                                <div className={style.treeNode} >
                                                    <div className={style.treeNodeClimber}></div>
                                                    <div className={style.treeNodeData} onClick={(e) => { e.preventDefault(); udpateDownlineTree(downliner.name); }}>
                                                        <div className={style.treeNodeProfileInfo}>
                                                            <div className={style.treeNodeProfile}>
                                                                <img src="" alt="" className={style.treeNodeProfile_img} />
                                                                <div className={style.treeNodeProfile_username}>
                                                                    @{downliner.name}
                                                                </div>
                                                            </div>

                                                            {/* <p className={style.treeNodeProfileInfoName}>Anwar jibewi</p> */}
                                                        </div>


                                                        <div className={style.treeNodeProfileData}>
                                                            <div className={style.treeNodeData_key}>Plan Type</div>
                                                            <div className={style.treeNodeData_value}>Essential</div>
                                                        </div>

                                                        <div className={style.treeNodeProfileData}>
                                                            <div className={style.treeNodeData_key}>Earnings</div>
                                                            <div className={style.treeNodeData_value}>{downliner.balance} USD</div>
                                                        </div>

                                                        <div className={style.treeNodeProfileData}>
                                                            <div className={style.treeNodeData_key}>Referrer</div>
                                                            <div className={style.treeNodeData_value}>@{downliner.referrer}</div>
                                                        </div>

                                                        <div className={style.treeNodeProfileData}>
                                                            <div className={style.treeNodeData_key}>Date Joined</div>
                                                            <div className={style.treeNodeData_value}>{downliner.dateJoined.slice(0, 10)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }


                                    </div>




                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default SyndicatePage;